import { Point } from '@shared/commons/Geometry';
import { LayersEnum } from './LayersEnum';
export class TerceraChartMouseEventArgs {
    constructor(ww, ev) {
        this.NeedRedraw = LayersEnum.None;
        this.window = ww;
        this._baseEvent = ev;
        this.Button = ev.button;
        this.X = ev.offsetX;
        this.Y = ev.offsetY;
        this.Delta = -1 * parseInt(ev.deltaY);
        this.Location = new Point(this.X, this.Y);
        this.ClientLocation = new Point(ev.clientX, ev.clientY);
    }
}
